import { OnInit, ChangeDetectorRef } from '@angular/core';
var TabComponent = /** @class */ (function () {
    function TabComponent(changeDetector) {
        this.changeDetector = changeDetector;
        this.hide = false;
        this._isActive = false;
    }
    Object.defineProperty(TabComponent.prototype, "isActive", {
        get: function () {
            return this._isActive;
        },
        set: function (value) {
            this._isActive = value;
            this.changeDetector.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    TabComponent.prototype.ngOnInit = function () {
    };
    return TabComponent;
}());
export { TabComponent };
